<template>
  <div class="page">
    <div class="app-container">
		<BaseSearch
		  v-model="searchData"
		  :formOptions="searchFormOption"
		  @handleSearch="handleSearch"
		>
		</BaseSearch>
		<el-button type="primary" @click="handleCall"
		  ><i></i> 查看通话中记录</el-button
		>
      <BaseTable
        ref="baseTable"
        url="/admin/customer/index"
        :tableData.sync="tableData"
        :columns="columns"
		:searchParams="searchData"
      >
	  <template #custom="{ scope }">
	    {{ scope.row.title }}
	  </template>
	  <template #handle="{ row }">
	    <el-button type="text" size="mini" @click="insbill(row)">算价</el-button>
		<el-button type="text" size="mini" @click="insbillList(row)">算价记录</el-button>
	  </template>
      </BaseTable>
	  </el-dialog>
	  <!-- 查询通话中记录 -->
	  	<el-dialog
		  title="通话中记录"
	  	  :visible.sync="dialogCall"
	  	  width="70%"
	  	  @close="dialogCall = false"
	  	>
	  	<el-table
	  		:data="callTableData"
	  		:stripe="true"
	  		:border = "true">
	  		<el-table-column prop="username" label="客户名称" align="center"></el-table-column>
	  		<el-table-column prop="tel" label="客户电话" align="center"></el-table-column>
	  		<el-table-column prop="idCard" label="身份证号" align="center"></el-table-column>
	  		<el-table-column prop="address" label="地址" align="center"></el-table-column>
			<el-table-column prop="carNo" label="车牌号" align="center"></el-table-column>
			<el-table-column prop="vin" label="车架号" align="center"></el-table-column>
			<el-table-column prop="engine" label="发动机号" align="center"></el-table-column>
			<el-table-column prop="nature" label="车辆性质" align="center"></el-table-column>
			<el-table-column prop="model" label="车型" align="center"></el-table-column>
			<el-table-column prop="carBeginDate" label="初登日期" align="center"></el-table-column>
	  		<el-table-column label="操作" align="center">
	  			<template #default="scope">
					<el-button type="text" size="mini" @click="insbill(scope.row)">算价</el-button>
					<el-button type="text" size="mini" @click="insbillList(scope.row)">算价记录</el-button>
	  			</template>
	  		</el-table-column>
	  	</el-table>
	  
	  </el-dialog>
    </div>
  </div>
</template>

<script>
import { columns } from "./columns";
import { searchFormOption } from "./formOptions";

export default {
  name: "Customer",
  comments: {},
  data() {
    return {
	  tableData: [],
	  formData: {},
	  searchData: {},
	  dialogCall: false,
	  callTableData: []
    };
  },
  computed: {
    columns,
	searchFormOption
  },
  created() {},
  methods: {
	insbill(row){
		this.$api.post(
		    "/admin/customer/addCustomer",
		    {
		      customerId: row.customerId,
		      username: row.username,
		      tel: row.tel,
			  address: row.address,
			  carNo: row.carNo,
			  vin: row.vin
		    },
		  ).then((res) => {
			  if(res.id == 0 || res.id == ''){
				  this.$message.warning("客户信息添加失败，请重试");
				  return;
			  }
              // 车牌号 填充规则 暂+车架号后6位
              let carNo = row.carNo;
              if((row.vin && carNo == '') || carNo == null){
              	carNo = '暂'+row.vin.slice(-6);
              }
              this.$router.push({
                path: "/issue/recording",
                query: {
              	 isCustomer: 1,
                 carNo: carNo,
              	 vin: row.vin,
              	 engineNo: row.engine,
              	 beginDate: row.carBeginDate,
              	 brandType: row.model,
              	 usetype: row.nature || '',
				 personName: row.username,
				 certNo: row.idCard,
				 tel: row.tel,
				 addr: row.address
                },
              });
          });
	},
	// 查看通话中的记录
	async handleCall() {
		const res = await this.$api.post("/admin/customer/index",{isCall:1});
		this.callTableData = res.data.data;
		this.dialogCall = true;
	},
	insbillList(row) {
		this.$router.push({
		  path: "/issue/search",
		  query: {
			 vin: row.vin,
		  },
		});
	},
	// 点击搜索
	handleSearch() {
	  // console.log(this.searchData);
	  this.$refs.baseTable.searchData();
	},
  },
};
</script>
